import React from "react";

interface JSONLDProps {
    JSONLD: object | string;
}
export default function JSONLD({ JSONLD }: JSONLDProps): JSX.Element {
    const schema = typeof JSONLD === "string" ? JSONLD : JSON.stringify(JSONLD);

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />;
}
